import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const ReportsType = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_REPORTS_TYPE:
      return { ...state, reportsType: action.value };
    case actions.SELECTED_REPORTS_TYPE:
      return { ...state, selectedReportsType: action.value };
    default:
      return state;
  }
};
export default ReportsType;
